import React from 'react';

import { IconWrapper } from '@/components/ui/IconWrapper';
import type { AuthError } from '@/features/auth/shared/types/auth';
import { cn } from '@/utils/cn';
import { CircleX, Info } from 'lucide-react';

interface AuthResponseBannerProps {
  error: AuthError | null;
  className?: string;
}

export const AuthResponseBanner: React.FC<AuthResponseBannerProps> = ({ error, className }) => {
  if (!error) return null;

  if (error.type === 'no_password') {
    return (
      <div
        className={cn(
          'border-secondary-200 bg-secondary-100 text-typography-900 flex min-h-9 w-81 items-center rounded-md border px-3 py-2 text-sm',
          className
        )}
      >
        <IconWrapper icon={Info} className="text-primary mr-2 shrink-0 pl-0 text-lg" />
        {error.message}
      </div>
    );
  }

  return (
    <div
      className={cn(
        'border-error-100 bg-error-50 flex min-h-9 w-81 items-center rounded-md border py-1 text-center text-sm text-neutral-950 transition-all duration-300',
        className
      )}
    >
      <IconWrapper icon={CircleX} className="text-error-500 mt-px pr-2 pl-3 text-lg" /> {error.message}
    </div>
  );
};
